












































































































import Vue from 'vue';

export default Vue.extend({
  name: 'UnternehmenItem',
  props: [
    'unternehmen'
  ],
  methods: {
    getBranche: function(id){
      return this.$store.getters.getBranche(id);
    },
    // parseUrl: function(url) {
    //   let urls = url;
    //   if(url.includes(';')) {
    //     urls = url.split(';');
    //   }
    //
    //   if(url.includes(',')) {
    //     urls = url.split(',');
    //   }
    //   if(Array.isArray(urls)){
    //     return urls.map((item) => {
    //         if(!item.trim().startsWith('https://') && !item.trim().startsWith('http://')){
    //           return `http://${item.trim()}`;
    //         } else {
    //           return item.trim();
    //         }
    //     });
    //   } else {
    //     if(!urls.trim().startsWith('https://') && !urls.trim().startsWith('http://')){
    //       urls = `http://${urls}`;
    //     }
    //     return [].concat(urls);
    //   }
    // }
  },
  computed: {
    link(): string {
      return `/unternehmen/${this.unternehmen.id}`;
    }
  }
});
